/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/memory_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  MemoryServiceCreateMemoryBlockBody,
  MemoryServiceGetDynamicMemoryBlockConfigSchemaBody,
  MemoryServiceListMemoryBlockDynamicEnumValuesBody,
  MemoryServiceReplaceMemoryContentBody,
  MemoryServiceUpdateMemoryBlockBody,
  MemoryServiceValidateMemoryBlockConfigSchemaBody,
  RpcStatus,
  V1DiffMemoryBlocksResponse,
  V1DynamicEnumValuesResponse,
  V1GetConfigSchemaResponse,
  V1ListMemoryBlockKindsResponse,
  V1ListMemoryBlocksResponse,
  V1MemoryBlock,
  V1MemoryContentResponse,
  V1ValidateConfigResponse,
  WorkspaceDeleteMemoryBlock200,
  WorkspaceDeleteMemoryBlockParams,
  WorkspaceDiffMemoryBlocksParams,
  WorkspaceGetMemoryBlockParams,
  WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  WorkspaceListMemoryBlocksParams,
} from '../../models';

/**
 * @summary Dynamic (layer-2) config schema for a memory_block kind, derived from its static values.
 */
export const workspaceGetDynamicMemoryBlockConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  memoryServiceGetDynamicMemoryBlockConfigSchemaBody: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/memory-blocks:dynamic-config`,
    memoryServiceGetDynamicMemoryBlockConfigSchemaBody,
    options,
  );
};

export const getWorkspaceGetDynamicMemoryBlockConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicMemoryBlockConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceGetDynamicMemoryBlockConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicMemoryBlockConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>
  >;
export type WorkspaceGetDynamicMemoryBlockConfigSchemaMutationBody =
  MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
export type WorkspaceGetDynamicMemoryBlockConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for a memory_block kind, derived from its static values.
 */
export const useWorkspaceGetDynamicMemoryBlockConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicMemoryBlockConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceGetDynamicMemoryBlockConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicMemoryBlockConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Re-resolves the dynamic option list for one memory block config field.
 */
export const workspaceListMemoryBlockDynamicEnumValues = (
  organization: string,
  workspace: string,
  agentId: string,
  memoryServiceListMemoryBlockDynamicEnumValuesBody: MemoryServiceListMemoryBlockDynamicEnumValuesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DynamicEnumValuesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/memory-blocks:dynamic-enum-values`,
    memoryServiceListMemoryBlockDynamicEnumValuesBody,
    options,
  );
};

export const getWorkspaceListMemoryBlockDynamicEnumValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceListMemoryBlockDynamicEnumValuesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceListMemoryBlockDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceListMemoryBlockDynamicEnumValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceListMemoryBlockDynamicEnumValuesBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceListMemoryBlockDynamicEnumValues(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListMemoryBlockDynamicEnumValuesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>
  >;
export type WorkspaceListMemoryBlockDynamicEnumValuesMutationBody =
  MemoryServiceListMemoryBlockDynamicEnumValuesBody;
export type WorkspaceListMemoryBlockDynamicEnumValuesMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Re-resolves the dynamic option list for one memory block config field.
 */
export const useWorkspaceListMemoryBlockDynamicEnumValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: MemoryServiceListMemoryBlockDynamicEnumValuesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListMemoryBlockDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceListMemoryBlockDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceListMemoryBlockDynamicEnumValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for a memory_block kind.
 */
export const workspaceGetStaticMemoryBlockConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/memory-blocks:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticMemoryBlockConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/memory-blocks:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticMemoryBlockConfigSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticMemoryBlockConfigSchemaQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticMemoryBlockConfigSchema(
      organization,
      workspace,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticMemoryBlockConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>
>;
export type WorkspaceGetStaticMemoryBlockConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticMemoryBlockConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticMemoryBlockConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticMemoryBlockConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for a memory_block kind.
 */

export function useWorkspaceGetStaticMemoryBlockConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticMemoryBlockConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticMemoryBlockConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetStaticMemoryBlockConfigSchemaQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ============================================================================
Validation
============================================================================
Validates a memory block's configuration without saving.
 */
export const workspaceValidateMemoryBlockConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  memoryServiceValidateMemoryBlockConfigSchemaBody: MemoryServiceValidateMemoryBlockConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/memory-blocks:validate`,
    memoryServiceValidateMemoryBlockConfigSchemaBody,
    options,
  );
};

export const getWorkspaceValidateMemoryBlockConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceValidateMemoryBlockConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceValidateMemoryBlockConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceValidateMemoryBlockConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: MemoryServiceValidateMemoryBlockConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceValidateMemoryBlockConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceValidateMemoryBlockConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>
  >;
export type WorkspaceValidateMemoryBlockConfigSchemaMutationBody =
  MemoryServiceValidateMemoryBlockConfigSchemaBody;
export type WorkspaceValidateMemoryBlockConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Validation
============================================================================
Validates a memory block's configuration without saving.
 */
export const useWorkspaceValidateMemoryBlockConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: MemoryServiceValidateMemoryBlockConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceValidateMemoryBlockConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: MemoryServiceValidateMemoryBlockConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceValidateMemoryBlockConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Memory Block CRUD (thread-scoped)
============================================================================
Lists the memory blocks for a thread.
 */
export const workspaceListMemoryBlocks = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListMemoryBlocksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListMemoryBlocksResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListMemoryBlocksQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceListMemoryBlocksParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListMemoryBlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListMemoryBlocksQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListMemoryBlocks>>
  > = ({ signal }) =>
    workspaceListMemoryBlocks(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListMemoryBlocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListMemoryBlocks>>
>;
export type WorkspaceListMemoryBlocksQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceListMemoryBlocksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
          TError,
          Awaited<ReturnType<typeof workspaceListMemoryBlocks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
          TError,
          Awaited<ReturnType<typeof workspaceListMemoryBlocks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Memory Block CRUD (thread-scoped)
============================================================================
Lists the memory blocks for a thread.
 */

export function useWorkspaceListMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListMemoryBlocksQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new memory block for a thread.
 */
export const workspaceCreateMemoryBlock = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  memoryServiceCreateMemoryBlockBody: MemoryServiceCreateMemoryBlockBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks`,
    memoryServiceCreateMemoryBlockBody,
    options,
  );
};

export const getWorkspaceCreateMemoryBlockMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: MemoryServiceCreateMemoryBlockBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: MemoryServiceCreateMemoryBlockBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceCreateMemoryBlock'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: MemoryServiceCreateMemoryBlockBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceCreateMemoryBlock(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCreateMemoryBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>
>;
export type WorkspaceCreateMemoryBlockMutationBody =
  MemoryServiceCreateMemoryBlockBody;
export type WorkspaceCreateMemoryBlockMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new memory block for a thread.
 */
export const useWorkspaceCreateMemoryBlock = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: MemoryServiceCreateMemoryBlockBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCreateMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: MemoryServiceCreateMemoryBlockBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceCreateMemoryBlockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a single memory block by ID for a thread.
 */
export const workspaceGetMemoryBlock = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetMemoryBlockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetMemoryBlockQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  blockId?: string,
  params?: WorkspaceGetMemoryBlockParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks/${blockId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetMemoryBlockQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetMemoryBlockQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetMemoryBlock>>
  > = ({ signal }) =>
    workspaceGetMemoryBlock(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId && blockId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetMemoryBlockQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetMemoryBlock>>
>;
export type WorkspaceGetMemoryBlockQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params: undefined | WorkspaceGetMemoryBlockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a single memory block by ID for a thread.
 */

export function useWorkspaceGetMemoryBlock<
  TData = Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceGetMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetMemoryBlockQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    blockId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a memory block from a thread.
 */
export const workspaceDeleteMemoryBlock = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: WorkspaceDeleteMemoryBlockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteMemoryBlock200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteMemoryBlockMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: WorkspaceDeleteMemoryBlockParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: WorkspaceDeleteMemoryBlockParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteMemoryBlock'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: WorkspaceDeleteMemoryBlockParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, blockId, params } =
      props ?? {};

    return workspaceDeleteMemoryBlock(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteMemoryBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>
>;

export type WorkspaceDeleteMemoryBlockMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a memory block from a thread.
 */
export const useWorkspaceDeleteMemoryBlock = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        blockId: string;
        params?: WorkspaceDeleteMemoryBlockParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: WorkspaceDeleteMemoryBlockParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceDeleteMemoryBlockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a memory block's configuration on a thread.
 */
export const workspaceUpdateMemoryBlock = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  memoryServiceUpdateMemoryBlockBody: MemoryServiceUpdateMemoryBlockBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks/${blockId}`,
    memoryServiceUpdateMemoryBlockBody,
    options,
  );
};

export const getWorkspaceUpdateMemoryBlockMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: MemoryServiceUpdateMemoryBlockBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: MemoryServiceUpdateMemoryBlockBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateMemoryBlock'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: MemoryServiceUpdateMemoryBlockBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, blockId, data } =
      props ?? {};

    return workspaceUpdateMemoryBlock(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateMemoryBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>
>;
export type WorkspaceUpdateMemoryBlockMutationBody =
  MemoryServiceUpdateMemoryBlockBody;
export type WorkspaceUpdateMemoryBlockMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a memory block's configuration on a thread.
 */
export const useWorkspaceUpdateMemoryBlock = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        blockId: string;
        data: MemoryServiceUpdateMemoryBlockBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateMemoryBlock>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: MemoryServiceUpdateMemoryBlockBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceUpdateMemoryBlockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Content Manipulation (for mutable blocks)
============================================================================
Replaces the entire content of a mutable memory block on a thread.
 */
export const workspaceReplaceMemoryContent = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  blockId: string,
  memoryServiceReplaceMemoryContentBody: MemoryServiceReplaceMemoryContentBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryContentResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks/${blockId}:replace`,
    memoryServiceReplaceMemoryContentBody,
    options,
  );
};

export const getWorkspaceReplaceMemoryContentMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: MemoryServiceReplaceMemoryContentBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: MemoryServiceReplaceMemoryContentBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceReplaceMemoryContent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: MemoryServiceReplaceMemoryContentBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, blockId, data } =
      props ?? {};

    return workspaceReplaceMemoryContent(
      organization,
      workspace,
      agentId,
      threadId,
      blockId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceReplaceMemoryContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>
>;
export type WorkspaceReplaceMemoryContentMutationBody =
  MemoryServiceReplaceMemoryContentBody;
export type WorkspaceReplaceMemoryContentMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Content Manipulation (for mutable blocks)
============================================================================
Replaces the entire content of a mutable memory block on a thread.
 */
export const useWorkspaceReplaceMemoryContent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        blockId: string;
        data: MemoryServiceReplaceMemoryContentBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceReplaceMemoryContent>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: MemoryServiceReplaceMemoryContentBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceReplaceMemoryContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the thread's effective memory-block list and the pinned
agent version's list side-by-side so callers can render a diff.
 */
export const workspaceDiffMemoryBlocks = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffMemoryBlocksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffMemoryBlocksResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDiffMemoryBlocksQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceDiffMemoryBlocksParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/memory-blocks:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceDiffMemoryBlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceDiffMemoryBlocksQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>
  > = ({ signal }) =>
    workspaceDiffMemoryBlocks(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceDiffMemoryBlocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>
>;
export type WorkspaceDiffMemoryBlocksQueryError = AxiosError<RpcStatus>;

export function useWorkspaceDiffMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceDiffMemoryBlocksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the thread's effective memory-block list and the pinned
agent version's list side-by-side so callers can render a diff.
 */

export function useWorkspaceDiffMemoryBlocks<
  TData = Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffMemoryBlocksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffMemoryBlocks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceDiffMemoryBlocksQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists available memory block kinds and their configuration schemas.
 */
export const workspaceListMemoryBlockKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListMemoryBlockKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/memory-blocks/kinds`,
    options,
  );
};

export const getWorkspaceListMemoryBlockKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/memory-blocks/kinds`,
  ] as const;
};

export const getWorkspaceListMemoryBlockKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListMemoryBlockKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>
  > = ({ signal }) =>
    workspaceListMemoryBlockKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListMemoryBlockKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>
>;
export type WorkspaceListMemoryBlockKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListMemoryBlockKinds<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListMemoryBlockKinds<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListMemoryBlockKinds<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available memory block kinds and their configuration schemas.
 */

export function useWorkspaceListMemoryBlockKinds<
  TData = Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListMemoryBlockKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListMemoryBlockKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
